<template src="./index.html">
</template>
<script>
import minhead from '../../../../common/minHead/index.vue'
import { getdata } from './data.js'
import { } from "@/api/iinvout";
import config from "../../../../../../configHttp";
import {xxtjb_detail_query,xxtjb_detail_update_remark} from "@/api/xxtjb";
export default {
	name: '',
	components: {
		minhead
	},
	props: {
		initdata: {
			type: Object,
			default: () => ({})
		}
	},
	data: function () {
		return {
			outlist: [],
			headData: getdata().headData,
			tableData: [{}],
			overlength: 0,
			pagination: getdata().pagination,
			hasAll: false,
			pageType: "4"
		}
	},
	created() {
		this.hasAll = this.initdata.companyCode !='';
		this.init();
	},
	methods: {
		geOoverLength(e) {
			this.overlength = e;
		},
		init() {
			this.getMxInfo();
		},
		// 导出结果
		outPutXXTJBMXResult() {
			let selectVal = this.$refs.tablebox.getSelectionval();
			let _params = {};
			_params.sort = "id";
			_params.order = "desc";
			_params.companyCode = this.initdata.companyCode;
			_params.suosq = this.initdata.suosq;
			_params.businessType = this.initdata.businessType;
			_params.businessTypeName = this.initdata.businessTypeName;
			_params.resRange = this.initdata.resRange;
			_params.resRangetType = this.initdata.type;
			_params.type = this.pageType;
			if (selectVal.length > 0) {
				_params.data = selectVal;
			}
			let req = {
				downUrl: config.baseURL + 'dataDisposeCenter/adjust/export/detail',
				typeObj: {
					toForm: false,
					fileName: '销项调节表明细' + this.$timestampToStr(new Date(), 'yyyyMMdd'),
					fileType: 'xlsx',
					failUrl: this.$winURl
				},
				params: _params
			};
			this.$downloadcommon(req);
		},
		//获取明细数据
		getMxInfo() {
			let params = {};
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.sort = "id";
			params.order = "desc";
			params.companyCode = this.initdata.companyCode;
			params.suosq = this.initdata.suosq;
			params.businessType = this.initdata.businessType;
			params.businessTypeName = this.initdata.businessTypeName;
			params.resRange = this.initdata.resRange;
			params.resRangetType = this.initdata.type;
			xxtjb_detail_query(params).then(res => {
				if (res.data.code == 1) {
					if (res.data.data) {
						this.tableData = res.data.data.records;
						this.pagination.total = res.data.data.total;
						this.pagination.paginationkey++;
					} else {
						this.tableData = [];
					}
				} else {
					this.$message.error(res.data.msg);
				}
			})
		},
    //刷新
    forRefresh(){
      this.pagination.pageNum = 1
      this.pagination.paginationkey++
      this.getMxInfo()
    },
		forback() {
			this.$emit("closesgdj", true)
		},
		sizechange(e) {
			this.pagination.pageSize = e
			this.getMxInfo()
		},
		currentChange(e) {
			this.pagination.pageNum = e
			this.getMxInfo()
		},
		currStationChange(v) {
			this.initdata.companyCode = v;
			this.getMxInfo();
		},
		editReamrk(e) {
			e.sfupdate = true;
			this.tableData = JSON.parse(JSON.stringify(this.tableData));
		},
		saveReamrk(e) {
			e.sfupdate = false;
			let params = {
				fapInfoId: e.fapInfoId,
				voucherId: e.voucherId,
				relationId: e.relationId,
				remark: e.remark
			};
			xxtjb_detail_update_remark(params).then(res => {
				if (res.data.code == 1) {
					this.tableData = JSON.parse(JSON.stringify(this.tableData));
				} else {
					this.$message.error(res.data.msg);
				}
			})
		}
	}
};
</script>


<style scoped lang="less">
@import url('./index.less');
</style>
